var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6425 0.703046C11.4317 0.273407 10.9863 0 10.4971 0C10.008 0 9.56656 0.273407 9.35181 0.703046L6.7947 5.87044L1.08395 6.69847C0.606726 6.76877 0.209041 7.09686 0.0618974 7.54603C-0.0852459 7.9952 0.0340594 8.49124 0.376068 8.82323L4.51994 12.8501L3.54164 18.5409C3.4621 19.0096 3.66094 19.4861 4.05465 19.7634C4.44836 20.0407 4.96933 20.0759 5.39883 19.8532L10.5011 17.1778L15.6034 19.8532C16.0329 20.0759 16.5539 20.0446 16.9476 19.7634C17.3413 19.4822 17.5401 19.0096 17.4606 18.5409L16.4783 12.8501L20.6222 8.82323C20.9642 8.49124 21.0875 7.9952 20.9364 7.54603C20.7852 7.09686 20.3915 6.76877 19.9143 6.69847L14.1996 5.87044L11.6425 0.703046Z",
    fill: "#FCC80F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowstar);
export default __webpack_public_path__ + "static/media/yellowstar.e05ba5fe1f255931da44148b59ebe9aa.svg";
export { ForwardRef as ReactComponent };